import request from '@/utils/request';


export const getQuestionPage = (params) => {
	return request({
		url: '/cms/question/page',
		method: 'get',
        params: params,
        headers: {
            'tenant-id': '1', // 替换为实际的 token 或其他值
            // 其他请求头...
          },
	});
};
export const getHelpPage = (params) => {
	return request({
		url: '/cms/alone-page/page',
		method: 'get',
        params: params,
        headers: {
            'tenant-id': '1', // 替换为实际的 token 或其他值
            // 其他请求头...
          },
	});
};

export const getAlonePageApi = id => {
	return request({
		url: `/cms/alone-page/get?id=${id}`,
		method: 'get',
        headers: { 
            'Content-Type': 'application/json' ,
            'tenant-id': '1',
        },
	});
};
export const postQuesion = data => {
	return request({
		url: '/cms/question/create',
		method: 'post',
		headers: { 
            'Content-Type': 'application/json' ,
            'tenant-id': '1',
        },
		data,
	});
};

export const getQuestionDetail = id => {
	return request({
		url: `/cms/question/get?id=${id}`,
		method: 'get',
        headers: { 
            'Content-Type': 'application/json' ,
            'tenant-id': '1',
        },
	});
};

export const getSingleImageObj = (params) => {
    return request({
        url: '/cms/alone-img/get', // 修改了URL路径
        method: 'get',
        params: { marker: params.marker }, // 将 params.marker 转换成对象的形式传递
        headers: {
            'tenant-id': '1', // 替换为实际的 token 或其他值
            // 其他请求头...
        },
    });
};
export const getCarouselList = (params) => {
    return request({
        url: '/cms/carousel/list', // 修改了URL路径
        method: 'get',
		params: { type: params.type }, // 将 params.marker 转换成对象的形式传递
        headers: {
            'tenant-id': '1', // 替换为实际的 token 或其他值
            // 其他请求头...
        },
    });
};
export const getMenuList = () => {
    return request({
        url: '/cms/web-menu/list', // 修改了URL路径
        method: 'get',
        headers: {
            'tenant-id': '1', // 替换为实际的 token 或其他值
        },
    });
};
export const getMenuPageList = () => {
    return request({
        url: '/cms/web-menu/listPage', // 修改了URL路径
        method: 'get',
        headers: {
            'tenant-id': '1', // 替换为实际的 token 或其他值
        },
    });
};
export const getVideoList = () => {
    return request({
        url: '/cms/video/list', // 
        method: 'get',
        headers: {
            'tenant-id': '1', 
        },
    });
};
  /**
* 单图片管理
*/
// getSingleImageObj: async (queryParams: any) => {
//     const headers = {
//       'tenant-id': '1',
//     };
//     const marker = {
//       'marker': queryParams.marker,
//     };
//     return await request.get(`/cms/alone-img/get?marker=` + queryParams.marker, { headers });
//   },



// WEBPACK FOOTER //
// ./src/api/api.js